import { Components } from "appworks/components/components";
import { AssetConfigSchema } from "appworks/config/asset-config-schema";
import { gameLoop } from "appworks/core/game-loop";
import { canvasManager } from "appworks/graphics/canvas/canvas-manager";
import { graphicsManager } from "appworks/graphics/graphics-manager";
import { particleManager } from "appworks/graphics/particles/particle-manager";
import { spineManager } from "appworks/graphics/spine/spine-manager";
import { loader } from "appworks/loader/loader";
import { gameState } from "appworks/model/game-state";
import { AuthRequestPayload } from "appworks/model/gameplay/requests/auth-request-payload";
import { Model } from "appworks/model/model";
import { commsManager } from "appworks/server/comms-manager";
import { Services } from "appworks/services/services";
import { stateMachine } from "appworks/state-machine/state-machine";
import { Sequence } from "appworks/utils/contracts/sequence";
import "pixi-filters";
import { AlertComponent } from "slotworks/components/alert/alert-component";
import { Setup } from "./boot/setup";
import { ci } from "./debug/ci";
import { Layers } from "./graphics/layers/layers";
import { deviceInfo } from "./utils/device-info";

declare const __DEBUG__: boolean;
declare const __ENVIRONMENT__: string;
export class AppWorks {
    public static go(
        setups: Setup | Setup[],
        assetworksData: any
    ) {

        const setupsArr = (Array.isArray(setups)) ? setups : [setups];

        setupsArr.forEach((setup) => {
            setup.setupGameDefinition();
            setup.setupCanvas();
            setup.setupComponents();
            setup.setupComms();
            setup.setupSound();
            setup.setupStates();

            const particleConfigs = setup.setupParticles();
            particleManager.initConfigs(particleConfigs);
        });

/////////////////////////////////////////////////////////
//////////////////
//////////////////

        window.onerror = (e) => {
            let message = Services.translations.get("General Error");

/////////////////////////////
////////////////////////////
///////////////////////////////////////
/////////////
//////////////////////

            Components.get(AlertComponent).error(message, true).execute();
            window.onerror = null;
        };

        commsManager.connector.onError((message, fatal) => Components.get(AlertComponent).error(message, fatal).execute());
        loader.onError((message) => Components.get(AlertComponent).error(message, true).execute());

        loader.loadConfig().then((assetConfig: AssetConfigSchema) => {

            Layers.gameLayers = assetworksData.gameLayers;

            canvasManager.init(assetConfig);
            graphicsManager.init(assetConfig);
            particleManager.init(assetConfig);
            spineManager.init(assetConfig);

            const layoutConfig = assetConfig.layouts[deviceInfo.layoutId].graphics;
            Layers.init(layoutConfig, assetworksData.LayerNames);

            setupsArr.forEach((setup) => {
                setup.setupLayers();
                setup.setupTransitions();
            });

            new Sequence([
                () => gameLoop.init(),
                ...setupsArr.map((setup) => () => setup.setupAsync())
            ]).then(() => {

                loader.loadI18n(Model.read().settings.language || loader.fallbackI18nFileNames[0]).then((json) => {

//////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////
/////////////////////
//////////////////////////////

                    Services.translations.setLanguage(Model.read().settings.language || loader.fallbackI18nFileNames[0]);
                    Services.translations.load(json);
                    Services.translations.updateDOMTexts();

                    setupsArr.forEach((setup) => {
                        setup.setupI18N();
                    });

                    gameState.newGame();

                    new Sequence([
                        () => loader.setup(assetConfig),
                        () => new Sequence(setupsArr.map((setup) => () => setup.setupAsync())),
                        () => commsManager.request(new AuthRequestPayload()),
                        () => loader.load()
                    ]).then(() => {
                        setupsArr.forEach((setup) => {
                            setup.setupUI();
                        });


                        canvasManager.gameLoaded();

//////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////
///////////////////////////////////////////////////
///////////////////////////////
/////////////////////////
//////////////////////////////////

                        setupsArr.forEach((setup) => {
                            setup.onReady();
                        });

                        stateMachine.start();
                    });
                });
            });
        });
    }

    private constructor() { }
}
